'use strict';

import '../scss/sernbrandt.scss';
import menuFunctionality from './modules/menu-functionality';
import productPageFunctionality from './modules/product-page';
import productListFunctionality from './modules/product-list';
import astraMods from './modules/astra-modifications';
jQuery(document).ready(function ($) {
  menuFunctionality();
  productPageFunctionality();
  productListFunctionality();
  astraMods();
  if ($('body').hasClass('single-product') && $('.ast-article-single .product_meta').length) {
    $('.ast-article-single .product_meta').insertAfter($('.wl-product__text-content .entry-title'));
  }
  $('a[href*="/produkt-kategori/begagnat"]').each(function () {
    if ($(this).attr('href').indexOf('v=') < 0) {
      var randomNumber = Math.floor(10000 + Math.random() * 90000);
      if ($(this).attr('href').indexOf('?') < 0) {
        $(this).attr('href', $(this).attr('href') + '?v=' + randomNumber);
      } else {
        $(this).attr('href', $(this).attr('href') + '&v=' + randomNumber);
      }
    }
  });
  if ($('.ast-article-single').length && $('.wl-product__container .woocommerce-breadcrumb').length) {
    $('.woocommerce-breadcrumb').detach().prependTo('.ast-woocommerce-container');
  }
  if (window.location.pathname.indexOf('/produkt-kategori/begagnat') > -1 && window.location.search.indexOf('v=') == -1) {
    var randomNumber = Math.floor(10000 + Math.random() * 90000);
    if (window.location.search.indexOf('?') == -1) {
      window.location.search = '?v=' + randomNumber;
    } else {
      window.location.search = '&v=' + randomNumber;
    }
  }
  if ($('#shipping_method').length && $('#shipping_method input').length) {
    $('#shipping_method li').each(function () {
      if ($('.woocommerce-Price-amount', this).length && $('.woocommerce-Price-amount', this).text().indxOf('9999') > -1) {
        $('#shipping_method_0_local_pickup4').trigger('click');
        $('#shipping_method').hide();
      }
    });
  }
});